
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC"}},[_c('path',{attrs:{"d":"M32.944 18.451h-7.698V21.6h7.698zM32.944 23.697h-7.698v3.148h7.698zM32.944 28.943h-7.698v3.147h7.698zM23.145 18.451h-7.698V21.6h7.698zM23.145 23.697h-7.698v3.148h7.698zM23.145 28.943h-7.698v3.147h7.698zM32.944 13.14h-7.698v3.148h7.698zM23.145 13.14h-7.698v3.148h7.698zM42.865 18.451h-7.698V21.6h7.698zM42.865 23.697h-7.698v3.148h7.698zM42.865 28.943h-7.698v3.147h7.698zM42.865 13.14h-7.698v3.148h7.698z"}}),_c('path',{attrs:{"d":"M29.333 23H2.667l10.666 12.613v8.72L18.667 47V35.613z"}})]),_c('path',{staticClass:"i-funnel",attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M27.333 21H.667l10.666 12.613v8.72L16.667 45V33.613z"}}),_c('path',{staticClass:"i-Vector 135",attrs:{"stroke":"#234652","d":"M11.436 18.847V4.645H47.14V36.42H19.093"}}),_c('path',{staticClass:"i-Line 128",attrs:{"stroke":"#234652","d":"M13.843 8.478h30.792"}})])
          )
        }
      }
    